import { getSelector } from './getSelector';

/**
 * Построение информации об элементе на основе данных об его положении.
 *
 * @param rect Положение элемента на странице.
 * @returns Информация о положении элемента в формате [x:<x_position>;y:<y_position>;w:<width>;h:<height>]
 */
function getRectInfo(rect: DOMRectReadOnly) {
    return `[x:${rect.x};y:${rect.y};w:${rect.width};h:${rect.height}]`;
}

/**
 * Хелпер для сбора дополнительной информации об элементе, который вызвал CLS.
 *
 * @kind helper
 * @param layoutShiftAttribution Содержимое LayoutShiftAttribution при логировании CLS.
 * @returns Дополнительная информация об элементе, который вызвал CLS, для отправки в Rum счетчик.
 **/
export function getCLSAdditionalParams(
    layoutShiftAttribution?: Ya.Rum.LayoutShiftAttribution | undefined | null
): Record<string, string> | undefined {
    if (!layoutShiftAttribution) {
        return;
    }

    const { node, previousRect, currentRect } = layoutShiftAttribution;

    return {
        // Селектор элемента, который вызвал CLS и unknown, если элемент не найден на странице.
        cls_selector: node ? getSelector(node) : 'unknown',
        // Информация о сдвиге элемента в формате: [<предыдущее положение/размер>]->[<текущее положение/размер>]
        cls_shift: `${getRectInfo(previousRect)}->${getRectInfo(currentRect)}`,
    };
}
